module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5uE4e"))).then(() => parcelRequire('37nVf'));